import axios from 'axios';
import APIS from '../../apis';
import {
  callbackHandler
} from '../callbackHandler';
import qs from 'qs';
import {
  factorArrayToChart,
  pick
} from '../../lib/units';

// 用一个唯一或特殊的字段，在json里提取出一个blockData
function getBlockDataFromListByField(list, field) {
  if (!list || !list.length) return;

  for (var i = list.length - 1; i >= 0; i--) {
    if (typeof list[i][field] !== 'undefined') {
      return list[i]
    }
  }
}

export default {
  state: {
    reportData: {},
  },
  mutations: {
    setReportData(state, payload) {
      state.reportData = payload;
    }
  },
  getters: {
    [`REPORT_QUESTIONNAIRE`]: function (state) {
      const that = this;
      const blockData = state.reportData.questionnaire;
      if (state.reportData.questionnaire == undefined) {
        return {}
      }
      const queInfo = {
        id: blockData.id,
        title: blockData.alias,
        content: blockData.intro,
      }
      return queInfo;
    },
    [`REPORT_SCALE`]: function (state) {
      const that = this;
      const scale = {};
      if (state.reportData.scale == undefined) {
        return {
          desc: '',
        }
      }
      scale.desc = state.reportData.scale.reportDescription;
      scale.showQRCode = !!(state.reportData.scale.isShowQrcode * 1);
      return scale;
    },
    [`REPORT_BASEINFO`]: function (state) {
      const that = this;
      const baseInfo = {};
      if (state.reportData.employeeTest == undefined) {
        return {
          title: '',
          userName: '',
          testDate: '',
        }
      }
      let date = new Date(state.reportData.employeeTest.lastCompletedDatetime);
      const fillZero = function (str) {
        let result = '';
        if (str * 1 < 10) {
          result = `0${str}`;
        } else {
          result = `${str}`;
        }
        return result;
      };
      baseInfo.title = state.reportData.scale.name;
      baseInfo.userName = state.reportData.employee.name;
      baseInfo.testDate = `${date.getFullYear()}.${fillZero(date.getMonth() + 1)}.${fillZero(date.getDate())} ${fillZero(date.getHours())}:${fillZero(date.getMinutes())}`;


      return baseInfo;


    },
    [`REPORT_SUMMARY`]: function (state) {
      const that = this;
      const viewData = {
        chart: {
          factorId: '',
          data: [],
          label: [],
          resultName: [],
          level: [],
          moduleIndexNumber: 0
        }
      };

      const blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'exponentFactorData');
      if (blockData == undefined) {
        // if (state.reportData.moduleDataList == undefined) {
        return viewData;
      }

      // const blockData = state.reportData.moduleDataList[0];
      const summary = viewData;
      // 指数型结果和组合型结果拼接
      summary.moduleIndexNumber = blockData.moduleIndexNumber;
      summary.title = blockData.moduleName;
      summary.chart.chartType = 'pointer';
      console.log(blockData)
      summary.chart.factorId = blockData.exponentFactorData.factorId;
      summary.chart.data.push(Math.round(blockData.exponentFactorData.scoringRatio));
      summary.chart.label.push(blockData.exponentFactorData.factorName);
      summary.chart.resultName.push(blockData.exponentFactorData.resultName);
      summary.chart.level.push(blockData.exponentFactorData.level);
      summary.result = blockData.exponentFactorData.resultDescription;
      // console.log(summary)
      return summary;
    },
    [`REPORT_SUMMARY_ANSWER`]: function (state) {
      const that = this;
      var blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'synthesisAnalysisResult');
      if (blockData == undefined) {
        // if (state.reportData.moduleDataList == undefined) {
        return {};
      }

      // const blockData = state.reportData.moduleDataList[0].synthesisAnalysisResult;
      return {
        title: blockData.synthesisAnalysisResult.moduleName,
        content: blockData.synthesisAnalysisResult.description,
        moduleIndexNumber: blockData.moduleIndexNumber
      }
    },

    /**
     * 解析雷达图数据。暂且这样标识
     * @author cyc
     */
    [`REPORT_RADAR`]: function (state) {
      var radarData, list, group = [];

      const blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'factorList');

      if (blockData) {
        radarData = blockData;
        list = radarData.factorList;

        if (list.length) {
          group.push(list.map(item => item.value));

          // 数据项有referenceAvgScore这个字段就认为有维度对比
          if (list[0].hasOwnProperty('referenceAvgScore') && list.filter(item => +item.referenceAvgScore).length) {
            group.push(list.map(item => item.referenceAvgScore));
          }

          return {
            group,
            title: radarData.moduleName,
            types: list.map(item => item.name),
            moduleIndexNumber: blockData.moduleIndexNumber
          };
        }
      } else {
        return {
          title: '',
          group: [],
          types: []
        }
      }
    },

    /**
     * 维度对比。暂且这样标识
     * @author cyc
     */
    [`REPORT_DIMENSION_COMPARISON`]: function (state) {
      var barData, list, comparison, transpose, types, shortTypes, maxLabelLength,
        resultItemKeys = ['level1FactorDatas', 'factorName', 'resultName', 'resultdescription', 'fillColor'],
        group = [];


      const blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'level2FactorVos');

      if (blockData) {
        barData = blockData
        list = barData.level2FactorVos;

        types = list.map(item => item.factorName);
        comparison = barData.factorComparison;
        transpose = !barData.factorComparisonStyle;
        maxLabelLength = Math.max.apply(Math, types.map(str => str.length));

        if (list.length) {
          group.push([], []);
          list.forEach(dimension => {
            group[0].push(dimension.level1FactorDatas[0].scoringRatio);
            group[1].push(dimension.level1FactorDatas[1].scoringRatio);
          });

          // 竖向排列时，如果label超过8个字，用字母代替
          if (comparison && ((transpose ? 7 : 0) < maxLabelLength)) {
            shortTypes = types.map(function (_, i) {
              return String.fromCharCode(65 + i);
            });
          }

          return {
            group,
            types,
            shortTypes,
            title: barData.moduleName,
            results: list.map(item => pick(item, resultItemKeys)),
            legend: [barData.factorComparatorLegend1, barData.factorComparatorLegend2],
            comparison,
            transpose,
            moduleIndexNumber: blockData.moduleIndexNumber
          };
        }
      } else {
        return {};
      }
    },

    [`REPORT_SUMMARY_FACTORS`]: function (state) {
      const that = this;
      const blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'level2FactorDataList');
      if (blockData == undefined) {
        // if (state.reportData.moduleDataList == undefined) {
        return {
          tabData: {},
          chart: {},
        };
      }

      // const blockData = state.reportData.moduleDataList[2];
      const summaryFactors = {
        chart: {},
        tabData: {},
        moduleIndexNumber: blockData.moduleIndexNumber
      };
      summaryFactors.title = blockData.moduleName;
      summaryFactors.chart = factorArrayToChart(blockData.level2FactorDataList);
      summaryFactors.chart.chartType = 'bar';
      summaryFactors.tabData.tabNames = blockData.level2FactorDataList.map(item => item.factorName);
      summaryFactors.tabData.tabConts = blockData.level2FactorDataList.map(function (item) {
        return {
          factorName: item.factorName,
          result: item.resultdescription,
          resultName: item.resultName,
          resultNameColor: item.fillColor,
        }
      });
      //        console.log(summaryFactors);
      return summaryFactors;
    },
    [`REPORT_DETAIL_ANALYSIS`]: function (state) {
      const that = this;
      const blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'factorGroups');
      if (blockData == undefined) {
        // if (state.reportData.moduleDataList == undefined) {
        return {
          tabData: {},
        };
      }

      // const blockData = state.reportData.moduleDataList[3];
      const detailAnalysis = {
        moduleIndexNumber: blockData.moduleIndexNumber,
        tabData: {
          tabNames: [],
          tabConts: [],
        },
      };
      detailAnalysis.title = blockData.moduleName;
      for (let i = 0; i < blockData.factorGroups.length; i++) {
        let item = blockData.factorGroups[i];
        if (item.level1FactorDatas.length > 0) {
          const tabCont = {};
          detailAnalysis.tabData.tabNames.push(item.name);
          tabCont.chart = factorArrayToChart(item.level1FactorDatas);
          tabCont.chart.chartType = 'line';
          tabCont.factors = [];
          for (let j = 0; j < item.level1FactorDatas.length; j++) {
            let curFactor = item.level1FactorDatas[j];
            tabCont.factors.push({
              factorName: curFactor.factorName,
              result: curFactor.resultDescription,
              resultName: curFactor.resultName,
              resultNameColor: curFactor.fillColor,
            })
          }
          detailAnalysis.tabData.tabConts.push(tabCont);
        }
      }
      return detailAnalysis;
    },
    [`REPORT_RESULTS`]: function (state) {
      const that = this;
      const blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'conclusions');
      if (blockData == undefined) {
        // if (state.reportData.moduleDataList == undefined) {
        return {};
      }

      // const blockData = state.reportData.moduleDataList[5];
      let result = {
        moduleIndexNumber: blockData.moduleIndexNumber
      };
      // result
      result.title = blockData.moduleName;
      result.result = [];
      for (let i = 0; i < blockData.conclusions.length; i++) {
        let item = blockData.conclusions[i];
        if (item.resultConclusion != '') {
          result.result.push(item.resultConclusion);
        }
      }

      return result;
    },
    [`REPORT_SUGGEST`]: function (state) {
      const that = this;
      const blockData = getBlockDataFromListByField(state.reportData.moduleDataList, 'resultProposals');
      if (blockData == undefined) {
        // if (state.reportData.moduleDataList == undefined) {
        return {};
      }

      // const blockData = state.reportData.moduleDataList[6];
      let suggest = {
        moduleIndexNumber: blockData.moduleIndexNumber
      };
      suggest.title = blockData.moduleName;
      suggest.suggest = [];
      for (let i = 0; i < blockData.resultProposals.length; i++) {
        let item = blockData.resultProposals[i];
        if (item.resultProposal != '') {
          suggest.suggest.push(item.resultProposal);
        }
      }
      return suggest;
    },
    [`REPORT_OTHERS`]: function (state) {
      const that = this;
      if (state.reportData.employee == undefined) {
        return {
          companyScaleId: '',
          accountId: '',
          scaleId: '',
          questionnaireId: '',
          employeeScaleId: '',
          orderId: '',
          shareTemplateMsg: {
            username: ''
          }
        };
      }
      const others = {
        companyScaleId: `${state.reportData.employee.companyScaleId}`,
        accountId: `${state.reportData.employee.accountId}`,
        scaleId: `${state.reportData.scale.id}`,
        questionnaireId: `${state.reportData.questionnaire.id}`,
        employeeScaleId: `${state.reportData.shareTemplateMsg.employeeScaleId}`,
        orderId: `${state.reportData.employeeTest.orderId}`,
        shareTemplateMsg: state.reportData.shareTemplateMsg,
      };
      return others;
    },
  },
  actions: {
    [`GET_REPORTDATA`]: function (context, {
      params,
      callback
    } = {}) {
      return axios.get(APIS.viewReport, {
        params
      }).then((res) => {
        callbackHandler(APIS.homePageBanner, res, callback);
        return res;
      })
    },
    [`GET_REPORT_RECOMMEND`]: function (context, {
      params,
      callback
    } = {}) {
      axios.get(APIS.getRelevantScalesForReport, {
        params
      }).then(res => {
        callbackHandler(APIS.homePageBanner, res, callback);
      })
    },
    [`GET_REPORT_COUPON`]: function (context, {
      params,
      callback
    } = {}) {
      axios.get(APIS.reportPageCouponReceive, {
        params
      }).then(res => {
        callbackHandler(APIS.homePageBanner, res, callback);
      })
    },
    [`GET_REPORT_SHARE_DATA`]: function (context, {
      params,
      callback
    } = {}) {
      axios.get(APIS.shareDetail, {
        params
      }).then((res) => {
        callback(res.data)
        // callbackHandler(APIS.shareDetail, res, callback);
      })
    },
    [`GET_REPORT_SHARE_SCALE_URL`]: function (context, {
      params,
      callback
    } = {}) {
      axios.get(APIS.getDetailUrl, {
        params
      }).then((res) => {
        callbackHandler(APIS.getDetailUrl, res, callback);
      })
    },
    [`GET_REPORT_SHARE_RECOMMEND`]: function (context, {
      isWechat,
      params,
      callback
    } = {}) {
      axios.get(isWechat ? APIS.shareRecommend_wx : APIS.shareRecommend_m, {
        params
      }).then((res) => {
        callback(res.data);
      })
    },
    [`PUSH_REPORT_SHARE_VOTE`]: function (context, {
      params,
      callback
    } = {}) {
      axios.get(APIS.vote, {
        params
      }).then((res) => {
        callback(res.data)
      })
    },
    // 报告页pdf
    //获取报告迁移服务订单状态
    [`GET_PDF_STATUS`]: function (context, {
      params,
      callback
    } = {}) {
      return axios.get(APIS.getPdfStatus, {
        params
      }).then((res) => {
        callbackHandler(APIS.getPdfStatus, res, callback);
        return res.data;
      })
    },
    //购买报告迁移服务
    [`BUY_PDF`]: function (context, {
      params,
      callback
    } = {}) {
      return axios.get(APIS.buyPdf, {
        params
      }).then((res) => {
        callbackHandler(APIS.buyPdf, res, callback);
        return res.data;
      })
    },
    //
    GET_BUY_PDF(context, {
      API,
      params
    }) {
      return axios.get(API, {
        params
      }).then(function (res) {
        callbackHandler(APIS.buyPdf, res);
        return res.data;
      })
    },
    //
    SEND_MAIL_WITH_PDF(context, {
      API,
      params
    }) {
      return axios.get(APIS.sendMailWithPdfNew, {
        params
      }).then(function (res) {
        callbackHandler(APIS.sendMailWithPdfNew, res);
        return res.data;
      })
    },
    //
    DELETE_REPORT(context, {
      API,
      params
    }) {
      return axios.get(APIS.deleteReport, {
        params
      }).then(function (res) {
        callbackHandler(APIS.deleteReport, res);
        return res.data;
      })
    },
    // 判断报告导咨询价格接口
    verifyConsultPrice(context, {
      API,
      params
    }) {
      return axios.get(APIS.verifyConsultPrice, {
        params
      }).then(function (res) {
        callbackHandler(APIS.verifyConsultPrice, res);
        return res.data;
      })
    },
    // 购买报告导咨询服务接口
    buyConsult(context, {
      API,
      params
    }) {
      return axios.get(APIS.buyConsult, {
        params
      }).then(function (res) {
        callbackHandler(APIS.buyConsult, res);
        return res.data;
      })
    },
    // 确认提交咨询表单接口
    submitConsultForm(context, {
      API,
      params
    }) {
      return axios.post(APIS.submitConsultForm, qs.stringify(params)).then((res) => {
        callbackHandler(APIS.submitConsultForm, res);
        return res.data;
      })
    },
    // 获取我的咨询订单接口
    getMyConsultOrderData(context, {
      API,
      params
    }) {
      return axios.get(API, {
        params
      }).then(function (res) {
        callbackHandler(API, res);
        return res.data;
      })
    },
    // 获取单个咨询表单详情接口
    getReportConsultForm(context, {
      API,
      params
    }) {
      return axios.get(APIS.getReportConsultForm, {
        params
      }).then(function (res) {
        callbackHandler(APIS.getReportConsultForm, res);
        return res.data;
      })
    },
    // 咨询订单是否有待确认红点接口
    verifyConsultFormRedDot(context, {
      API,
      params
    }) {
      return axios.get(APIS.verifyConsultFormRedDot, {
        params
      }).then(function (res) {
        callbackHandler(APIS.verifyConsultFormRedDot, res);
        return res.data;
      })
    },
    closeConsultModule(context, {
      API,
      params
    }) {
      return axios.get(APIS.closeConsultModule, {
        params
      }).then(function (res) {
        callbackHandler(APIS.closeConsultModule, res);
        return res.data;
      })
    },
    getConsultModuleStatus(context, {
      API,
      params
    }) {
      return axios.get(APIS.getConsultModuleStatus, {
        params
      }).then(function (res) {
        callbackHandler(APIS.getConsultModuleStatus, res);
        return res.data;
      })
    },
    getReportDataUrl(context, {
      API,
      params
    }) {
      return axios.get(APIS.getReportDataUrl, {
        params
      }).then(function (res) {
        callbackHandler(APIS.getReportDataUrl, res);
        return res.data;
      })
    },

    getConsultReadingReportTeachers(context, {
      params
    }) {
      return axios.get(APIS.getConsultReadingReportTeachers, {
        params
      }).then(function (res) {
        return res.data;
      })
    },

    getCpConsultantCpDiversion(context, {
      params
    }) {
      return axios.get(APIS.cpConsultantCpDiversion, {
        params
      }).then(function (res) {
        return res.data;
      })
    },

    fetchCommonDistributionCard(context, { params }) {
      return axios.get(APIS.getCommonDistributionCard, {
        params
      }).then(function (res) {
        return res.data;
      })
    },
    fetchAppHeartCoach(context, { params }) {
      return axios.get(APIS.getAppHeartCoach, {
          params
      }).then(function (res) {
          return res.data;
      })
    },

    fetchGuideData(context, {
      params
    }) {
      return axios.get(APIS.fetchGuideData, {
        params
      }).then(function (res) {
        return res.data;
      })
    },

    getConsultDescription(context, { params }) {
      return axios.get(APIS.getConsultDescription, {
        params
      }).then(function (res) {
        return res.data;
      })
    },

    getTeacherAndPrice(context, { params }) {
      return axios.get(APIS.getTeacherAndPrice, {
        params
      }).then(function (res) {
        return res.data;
      })
    },

    fetchAppConsultantInfo(context, {
      params
    }) {
      return axios.get(APIS.fetchAppConsultantInfo, {
        params
      }).then(function (res) {
        return res.data;
      })
    },

    fetchAppGuideData(context, {
      params
    }) {
      return axios.get(APIS.fetchAppGuideData, {
        params
      }).then(function (res) {
        return res.data;
      })
    },

    getCpConsultantOpenInvitee(context, {
      params
    }) {
      return axios.get(APIS.cpConsultantOpenInvitee, {
        params
      }).then(function (res) {
        return res.data;
      })
    },
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/report.js